import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { SideNavBarVisibilityService } from "../../services/side-nav-bar-visibility.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { ZpDataService } from "../../services/zp-data.service";
import { Subscription } from "rxjs";
import { UserInfoService } from "../../services/user-info.service";
import { AdminDashboardService } from "../../services/admin-dashboard.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-account-details",
    templateUrl: "./account-details.component.html",
    styleUrls: ["./account-details.component.scss"],
    standalone: false
})
export class AccountDetailsComponent implements OnInit {
  public routeLinks: any[];
  public chosenTab: string;
  public id: string;
  public user: {};
  public allUsers: [];
  public showDetailUser: boolean;
  @Input() public dataUser;
  @Output() public userOutputValue = new EventEmitter();
  @Output() public onClick = new EventEmitter();

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private ZpDataService: ZpDataService,
    private admin: AdminDashboardService,
    public themeService: ThemeService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get("Id");
    });
  }

  ngOnInit() {
    this.openTab(null, "profile");
    this.showDetailUser = false;
    // this.user = this.admin.users.find(user => user.Id == this.id)
    this.userOutputValue.emit(this.user);
  }

  openTab(evt, tabName) {
    this.chosenTab = tabName;
    let i, tabcontent;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    document.getElementById(tabName).style.display = "block";
  }

  goBack(): void {
    this.showDetailUser = false;
    this.onClick.emit();
  }
}
